import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import About from "@/pages/marketing/About";
import PrivacyPolicy from "@/pages/marketing/PrivacyPolicy";
import TermsOfService from "@/pages/marketing/TermsOfService";
import IncidentReviewPolicy from "@/pages/marketing/IncidentReviewPolicy";
import DisputeResolutionPolicy from "@/pages/marketing/DisputeResolutionPolicy";
import DataRetentionPolicy from "@/pages/marketing/DataRetentionPolicy";
import ComplianceFramework from "@/pages/marketing/ComplianceFramework";

/**
 * Standalone marketing / landing site. Deploys independently of the SaaS app.
 *
 * The product application now lives behind /login on the main React app
 * (see /app/frontend/src/App.js). Every "Sign in" / "Join GuestIntel" CTA
 * in this site hits /login on the app domain — set REACT_APP_APP_URL at
 * build time to point to the deployed app's origin if you serve the
 * landing site from a different host.
 */
export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/incident-review" element={<IncidentReviewPolicy />} />
          <Route path="/dispute-resolution" element={<DisputeResolutionPolicy />} />
          <Route path="/data-retention" element={<DataRetentionPolicy />} />
          <Route path="/compliance-framework" element={<ComplianceFramework />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </div>
  );
}
